import type { KeyboardEvent } from 'react'

const STEP: Record<string, (index: number, count: number) => number> = {
  ArrowDown: (index, count) => (index + 1) % count,
  ArrowUp: (index, count) => (index - 1 + count) % count,
  Home: () => 0,
  End: (_, count) => count - 1,
}

export const moveFocus = (selector: string) => (event: KeyboardEvent<HTMLElement>) => {
  const step = STEP[event.key]
  if (!step || (event.target as HTMLElement).closest('input, textarea')) return

  const items = [...event.currentTarget.querySelectorAll<HTMLElement>(selector)].filter(
    item => !item.hasAttribute('disabled'),
  )
  if (!items.length) return

  event.preventDefault()
  event.stopPropagation()
  const index = items.indexOf(document.activeElement as HTMLElement)
  items[step(index, items.length)].focus()
}
